import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SelectComponent from "../UniversalComponents/SelectComponent";
import Button from "../UniversalComponents/DefaultButton";
import DefaultOutline from "../UniversalComponents/DefaultOutline";

const DATE_OPTIONS = [
  "Custom",
  "Today",
  "Yesterday",
  "This Week",
  "This Month",
  "This Quarter",
  "This Year",
  "Last Week",
  "Last Month",
];

const ActivityLogFilter = ({ users = [], events = [], onFilterChange }) => {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [selectedDateOption, setSelectedDateOption] = useState("Today");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const userOptions = users.map((user) => ({
    label: user.name || "Unnamed User",
    value: user.id,
  }));

  const eventOptions = events.map((event) => ({
    label: event.event_label,
    value: event.event_value,
  }));

  const getDateRange = (option) => {
    const now = new Date();
    let start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    start.setHours(0, 0, 0, 0);

    let end = new Date(start);
    end.setDate(end.getDate() + 1);
    end.setHours(0, 0, 0, 0);

    switch (option) {
      case "Today":
        break;
      case "Yesterday":
        start.setDate(start.getDate() - 1);
        end.setDate(end.getDate() - 1);
        break;
      case "This Week":
        const dayOfWeek = start.getDay();
        start.setDate(start.getDate() - dayOfWeek);
        end.setDate(end.getDate() + 7);
        break;
      case "This Month":
        start.setDate(1);
        end.setMonth(end.getMonth() + 1);
        end.setDate(1);
        break;
      case "This Quarter":
        const quarter = Math.floor(now.getMonth() / 3);
        start.setMonth(quarter * 3);
        start.setDate(1);
        end.setMonth((quarter + 1) * 3);
        end.setDate(1);
        break;
      case "This Year":
        start.setMonth(0);
        start.setDate(1);
        end.setFullYear(end.getFullYear() + 1);
        end.setMonth(0);
        end.setDate(1);
        break;
      case "Last Week":
        start.setDate(start.getDate() - now.getDay() - 7);
        end.setDate(end.getDate() - now.getDay());
        break;
      case "Last Month":
        start.setMonth(start.getMonth() - 1);
        start.setDate(1);
        end.setMonth(end.getMonth());
        end.setDate(1);
        break;
      case "Custom":
        if (fromDate && toDate) {
          start = new Date(fromDate);
          start.setHours(0, 0, 0, 0);
          end = new Date(toDate);
          end.setHours(0, 0, 0, 0);
          end.setDate(end.getDate() + 1);
        } else {
          return { start: null, end: null };
        }
        break;
      default:
        return { start: null, end: null };
    }

    return {
      start: start.toISOString(),
      end: end.toISOString(),
    };
  };

  const handleUserChange = (e) => {
    let values = [];
    if (Array.isArray(e) && e.length > 0 && e[0]?.target?.valueObj) {
      values = e[0].target.valueObj;
    } else if (Array.isArray(e)) {
      values = e;
    } else if (e && e.target?.valueObj) {
      values = e.target.valueObj;
    } else if (e) {
      values = [e];
    }
    setSelectedUsers(values);
  };

  const handleEventChange = (e) => {
    let values = [];
    if (Array.isArray(e) && e.length > 0 && e[0]?.target?.valueObj) {
      values = e[0].target.valueObj;
    } else if (Array.isArray(e)) {
      values = e;
    } else if (e && e.target?.valueObj) {
      values = e.target.valueObj;
    } else if (e) {
      values = [e];
    }
    setSelectedEvents(values);
  };

  const handleApplyFilter = () => {
    const usersArray = Array.isArray(selectedUsers) ? selectedUsers : [];
    const eventsArray = Array.isArray(selectedEvents) ? selectedEvents : [];

    const userIds = usersArray.map((u) => u?.value).filter(Boolean);
    const eventValues = eventsArray.map((e) => e?.value).filter(Boolean);

    const { start, end } = getDateRange(selectedDateOption);

    const payload = {
      user_ids: userIds,
      events: eventValues,
      // date_option: selectedDateOption,
      start_date: start,
      end_date: end,
      page: 1,
      limit: 10,
    };
    onFilterChange(payload);
  };

  return (
    <div className="sticky top-0 bg-white z-50 p-2 flex flex-wrap items-end gap-4 ">
      <div className="flex flex-col flex-1 min-w-[200px]">
        <label className="text-sm font-Inter font-medium mb-1 text-gray-500">User</label>
        <SelectComponent
          options={userOptions}
          placeholder="All Users"
          multiSelect
          showSearch
          onChange={handleUserChange}
        />
      </div>

      <div className="flex flex-col flex-1 min-w-[160px]">
        <label className="text-sm font-Inter font-medium mb-1 text-gray-500">Date Changed</label>
        <select
          value={selectedDateOption}
          onChange={(e) => setSelectedDateOption(e.target.value)}
          //   className="border  rounded-md px-2 py-1 text-sm focus:border-primary"
          // >
          className=" border rounded-md px-2 py-1 text-sm text-gray-400
    focus:border-primary
    focus:outline-none
    focus:ring-0
  "
        >
          {DATE_OPTIONS.map((option) => (
            <option key={option}>{option}</option>
          ))}
        </select>
      </div>

      {selectedDateOption === "Custom" && (
        <>
          <div className="flex flex-col min-w-[160px]">
            <label className="text-sm font-Inter font-medium mb-1 text-gray-500">From</label>
            <DatePicker
              selected={fromDate}
              onChange={(date) => setFromDate(date)}
              className="border border-gray-300 rounded-md px-2 py-1 text-sm"
              placeholderText="Select From"
              dateFormat="dd MMM yyyy"
            />
          </div>

          <div className="flex flex-col min-w-[160px]">
            <label className="text-sm font-Inter font-medium mb-1 text-gray-500">To</label>
            <DatePicker
              selected={toDate}
              onChange={(date) => setToDate(date)}
              className="border border-gray-300 rounded-md px-2 py-1 text-sm"
              placeholderText="Select To"
              dateFormat="dd MMM yyyy"
            />
          </div>
        </>
      )}

      <div className="flex flex-col flex-1 min-w-[200px]">
        <label className="text-sm font-Inter font-medium mb-1 text-gray-500">Events</label>
        <SelectComponent
          options={eventOptions}
          placeholder="All Events"
          multiSelect
          showSearch
          onChange={handleEventChange}
        />
      </div>

      <div className="flex items-end min-w-[120px]">
        {/* <button
          onClick={handleApplyFilter}
          className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
        >
          Apply Filter
        </button> */}
        {/* <Button onClick={handleApplyFilter} isLoading> Apply Filter</Button> */}
        <DefaultOutline onClick={handleApplyFilter}>Apply Filter</DefaultOutline>
      </div>
    </div>
  );
};

export default ActivityLogFilter;
